import { RouteObject } from 'react-router-dom';
import FleetDashboard from '../FleetDashboard';

import { CompaniesRoutes } from '../Companies/routes/CompaniesRoutes';
import { ReportingDashboardRoutes } from '../Dashboard/routes/routes';
import { CostRoutes } from '../Cost/routes';
import { AssignmentsRoutes } from '../Assignment/routes';
import { BusinessesRoutes } from '../Businesses/routes';
import { FinancesRoutes } from '../Finances/routes';
import { VehiclesRoutes } from '../Vehicles/routes';
import { DriversRoutes } from '../Drivers/routes';
import { ServicesRoutes } from '../Services/routes/ServicesRoutes';

export const FleetRoutes: RouteObject[] = [
  { index: true, element: <FleetDashboard /> },
  ...CostRoutes,
  ...AssignmentsRoutes,
  ...BusinessesRoutes,
  ...CompaniesRoutes,
  ...FinancesRoutes,
  ...VehiclesRoutes,
  ...DriversRoutes,
  ...ServicesRoutes,
  ...ReportingDashboardRoutes,
];
